import React, { useContext, useEffect, useRef } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "./SuperstarRoute";
import "./assets/css/styles.css";
import { io } from "socket.io-client";
import Navbar from "../../Layouts/Navbar";
import StarSidebar from "../../Layouts/StarSidebar";
import { serverInfo } from "../../App";

const MasterLayout = () => {
  const socket = useRef();
  const { shoketUrl } = useContext(serverInfo);

  useEffect(() => {
    socket.current = io(shoketUrl);
    const user_id = localStorage.getItem("auth_id");
    socket.current.emit("addUser", user_id);
  }, []);

  return (
    <div className="sb-nav-fixed">
      <Navbar />

      <div id="layoutSidenav">
        <div id="layoutSidenav_nav">
          <StarSidebar />
        </div>

        <div id="layoutSidenav_content">
          <main className="p-3" style={{ background: "#151515" }}>
            <Switch>
              {routes.map((route, idx) => {
                return (
                  route.component && (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      render={(props) => <route.component {...props} />}
                    />
                  )
                );
              })}
              <Redirect from="/superstar" to="/superstar/dashboard" />
            </Switch>
          </main>

          {/*<Footer></Footer>*/}
        </div>
      </div>
    </div>
  );
};

export default MasterLayout;
